import apiClient from "./client";
import { normalizeSolutionLanguage } from "../utils/solutionLanguageMerge";

export const getPublicSolutions = async (language = "en") => {
  const lang = normalizeSolutionLanguage(language);
  const response = await apiClient.get("/solutions", { params: { language: lang } });
  return response.data;
};

export const getPublicSolutionByKey = async (solutionKey, language = "en") => {
  const key = String(solutionKey || "").trim();
  if (!key) return null;

  const lang = normalizeSolutionLanguage(language);

  try {
    const response = await apiClient.get("/solutions", { params: { language: lang } });
    const data = response?.data;
    if (!Array.isArray(data)) return null;
    return (
      data.find((it) => String(it?.solutionKey || "").toLowerCase() === key.toLowerCase()) || null
    );
  } catch {
    return null;
  }
};
